import { useEffect } from 'react';

const useVersionCheck = () => {
  useEffect(() => {
    const checkVersion = async () => {
      try {
        const res = await fetch('/version.json?t=' + Date.now());
        const { version } = await res.json();

        const saved = localStorage.getItem('app_version');

        if (saved && saved !== version) {
          localStorage.setItem('app_version', version);
          window.location.reload(true); // auto hard refresh
        } else {
          localStorage.setItem('app_version', version);
        }
      } catch (e) {
        console.error('Version check failed', e);
      }
    };

    checkVersion();
  }, []);
};

export default useVersionCheck;